/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API54440Req {
  
  /** 任务ID(Long) */
  taskId: string;
  /** 任务ID */
  taskId?: number;
};



export interface API54440Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 54440 任务催办

export interface IUsePostAPI54440Return {
  /** 任务催办: 接口请求状态 */
  isAPI54440Loading: boolean;
  /** 任务催办: 接口请求返回数据 */
  dataAPI54440: API54440Res;
  /**  任务催办: 接口数据请求方法 */
  fetchAPI54440Data:  (inputs: API54440Req, config?: YWRequestConfig) => Promise<API54440Res>;
  /** 任务催办: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI54440 = ():IUsePostAPI54440Return => {
  let isMount = true;
  const [isAPI54440Loading, setIsAPI54440Loading] = useState(false);
  const [dataAPI54440, setDataAPI54440] = useState<API54440Res>({} as API54440Res);
  const requestUrl = `${basePath}/team-work/workTask/notify`;

  const fetchAPI54440Data = async (inputs: API54440Req, config?: YWRequestConfig): Promise<API54440Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API54440Req>) || {}) as API54440Req;
    
  
    if ( isMount ) {
      setIsAPI54440Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API54440Res>(`${basePath}/team-work/workTask/notify`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI54440(res || {} as API54440Res);
        setIsAPI54440Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI54440Loading(false);
      }
      return false as unknown as API54440Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI54440Loading,
    dataAPI54440,
    fetchAPI54440Data,
    requestUrl,
  }
}

